import LeaveTypeColour from '@/support/LeaveTypeColour'
import LeaveTypesQuery from '@/graphql/queries/leave-types'
import {
  CREATE_LEAVE_TYPE,
  UPDATE_LEAVE_TYPE,
  DELETE_LEAVE_TYPE,
  CHANGE_DEFAULT_LEAVE_TYPE,
} from '@/graphql/mutations/leave-types'

export default class LeaveTypes {
  static async all(apollo, companyId) {
    const { data } = await apollo.query({
      query: LeaveTypesQuery,
      fetchPolicy: 'no-cache',
      variables: { company: companyId },
    })

    return data.companyProfile.leaveTypes.map(leaveType => ({
      ...leaveType,
      colour: LeaveTypeColour.fromName(leaveType.colour),
    }))
  }

  static create(apollo, leaveType) {
    return apollo.mutate({
      mutation: CREATE_LEAVE_TYPE,
      variables: { input: this.toInput(leaveType) },
    })
  }

  static update(apollo, leaveType) {
    return apollo.mutate({
      mutation: UPDATE_LEAVE_TYPE,
      variables: {
        input: { ...this.toInput(leaveType), leaveType: leaveType.id },
      },
    })
  }

  static destroy(apollo, { company, leaveType }) {
    return apollo.mutate({
      mutation: DELETE_LEAVE_TYPE,
      variables: { company, leaveType },
    })
  }

  static changeDefault(apollo, { company, leaveType }) {
    return apollo.mutate({
      mutation: CHANGE_DEFAULT_LEAVE_TYPE,
      variables: { company, leaveType },
    })
  }

  static toInput(leaveType) {
    return {
      company: leaveType.company_id,
      name: leaveType.name,
      colour: LeaveTypeColour.nameOf(leaveType.colour),
      displayIcon: leaveType.display_icon,
      approval: leaveType.approval,
      onlyAdmin: leaveType.only_admin,
      isPrivate: leaveType.is_private,
      isReasonPublic: leaveType.is_reason_public,
      accountsToConflicts: leaveType.accounts_to_conflicts,
      description: leaveType.description,
      allowanceTypeId: leaveType.allowance_type_id || null,
    }
  }
}
